import { render } from "./XacNhanHanhKhachXuongXe.vue?vue&type=template&id=0e88cf7e"
import script from "./XacNhanHanhKhachXuongXe.vue?vue&type=script&lang=js"
export * from "./XacNhanHanhKhachXuongXe.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__